import { Config } from '@/types';
import { useConfigStore } from './stores';

interface Params<
  K extends Config.CustomComponentNames,
  T extends Config.CustomComponent<K>,
> {
  componentName: K;
  Component: T;
}

export const useCustomComponent = <
  K extends Config.CustomComponentNames,
  T extends Config.CustomComponent<K>,
>({
  componentName,
  Component,
}: Params<K, T>) => {
  const config = useConfigStore();
  const CustomTemplate = config.customComponents?.[componentName];

  if (CustomTemplate) return CustomTemplate;

  return Component;
};
